import { useEffect, useState } from "react";
import Button from "../../../components/Button/Button";
import { useDebtResult } from "../../../contexts/DebtContext";
import { colors } from "../../../styles/Colors";
import { TextBold, TextRegular } from "../../../styles/GlobalStyledComponents";
import SuccessImg from "../../../assets/images/Success/successImg.svg";
import TokenService from "../../../services/Token";
import IframeService from "../../../services/Iframe";
import { ROUTES_PATH } from "../../../constants";

import { useLocation, useNavigate } from "react-router-dom";
import { useUserResult } from "../../../contexts/UserContext";
import {
  StandardPaymentType,
  StandardPaymentsData,
  TransactionReasonEnum,
} from "../../../interfaces/Debt";
import FinancialService from "../../../services/Financial";
import { useCardsResult } from "../../../contexts/CardsContext";
import { usePaymentSelected } from "../../../contexts/PaymentSelectedContext";
import { loadFromSessionStorage } from "../../../utils/sessionStorageHelper";
import GAnalyticsService from "../../../services/GAnalytics/ganalytics.service";
import dayjs from "dayjs";
import {
  ImgWrapper,
  ModalImgDiv,
  ModalTextWrapper,
  ModalWrapper,
} from "../FinalModalStyledComponents";
import { SuccessButtonContainer } from "./SuccessStyledComponents";
import { ViewMode } from "../../../interfaces/Mode";
import { getRedirectionUrl, getUtmParams } from "../../../utils/urlParams";
import { handleBizumSuccessEnd } from "../../../utils/paymentsHelper";

const Success = () => {
  const navigate = useNavigate();
  const { red4, white } = colors;
  const { isVerifyCard } =
    useLocation().state || sessionStorage.getItem("isVerifyCard") === "true";
  const { debtResult } = useDebtResult();
  const { paymentSelected, createPaymentSelected, deleteCoPaymentSelected } =
    usePaymentSelected();
  const { userResult } = useUserResult();
  const { createCardsResult } = useCardsResult();
  const canAdvaceFee = JSON.parse(
    sessionStorage.getItem("able-to-advance-fee") || "{}",
  );
  const advanceFeeOK = JSON.parse(
    sessionStorage.getItem("advance-fee-OK") || "false",
  );
  const finalParams = getUtmParams(true);
  const comeFromNoDebt = sessionStorage.getItem("come-from-nodebt");
  const viewMode = sessionStorage.getItem("pepper-view-mode");
  const isCo = sessionStorage.getItem("flow") === "co";
  const [isZero, setIsZero] = useState<boolean>(false);
  const [initTime] = useState<dayjs.Dayjs>(dayjs());

  const handleRedirection = () => {
    if (
      viewMode === ViewMode.APP ||
      viewMode === ViewMode.IFRAME ||
      viewMode === ViewMode.CLIENTES
    ) {
      if (viewMode === ViewMode.APP) {
        window.parent.postMessage(
          {
            data: "success",
            params: {
              amount: paymentSelected?.amount,
              payment_method: sessionStorage.getItem("pepper-payment-method"),
            },
          },
          "*",
        );
      } else if (viewMode === ViewMode.CLIENTES) {
        const winRef = window.opener;
        if (winRef) {
          const targetOrigin = document.referrer;
          winRef.postMessage(
            {
              data: "success",
              params: {
                amount: paymentSelected?.amount,
                payment_method: sessionStorage.getItem("pepper-payment-method"),
              },
            },
            targetOrigin,
          );
        }
      } else {
        IframeService.closeIframe("success");
      }
      TokenService.clearSession();
    } else {
      TokenService.clearSession();
      window.location.href = getRedirectionUrl(finalParams);
    }
  };

  //NUEVA LOGICA PARA ADELANTAR LA CUOTA
  const handleAdvanceFee = async () => {
    const cards = await FinancialService.getPaymentCards(
      userResult?.document_id as string,
    );
    createCardsResult(cards);
    GAnalyticsService.savePaymentMethodsDataLayer(cards);
    GAnalyticsService.sendInAdvancePayment(initTime);
    sessionStorage.setItem("able-to-advance-fee", "false");
    sessionStorage.setItem("advance-fee", "true");
    //SE CREA EL NUEVO PAGO
    const newPayment: StandardPaymentsData = {
      amount: comeFromNoDebt
        ? parseFloat(Number(debtResult?.promotions[0].amount).toFixed(2))
        : parseFloat(Number(debtResult?.loans[0].next_due_fee).toFixed(2)),
      amount_excused: 0 as number,
      loan_id: comeFromNoDebt
        ? (debtResult?.promotions[0].loan_id as string)
        : (debtResult?.loans[0].loan_id as string),
      transaction_reason: TransactionReasonEnum.PAN,
      type: StandardPaymentType.PayFee,
    };
    createPaymentSelected(newPayment);
    navigate(ROUTES_PATH.TYPES_PAYMENTS);
  };

  useEffect(() => {
    //Cuando exista el campo categoría en el método de pago seleccionado va a implicar que hemos seleccionado una promoción
    const paymentSelected = loadFromSessionStorage(
      "pepper-user-payment-selected",
    );
    paymentSelected && paymentSelected.category
      ? GAnalyticsService.saveUsedPromotion(true)
      : GAnalyticsService.saveUsedPromotion(false);

    const coPaymentSelected = loadFromSessionStorage(
      "pepper-user-co-payment-selected",
    );
    if (coPaymentSelected) {
      deleteCoPaymentSelected();
    }
    const creatingPaymentPlan = loadFromSessionStorage("pepper-payment-plan");
    if (creatingPaymentPlan) {
      sessionStorage.removeItem("pepper-payment-plan");
      sessionStorage.removeItem("pepper-payment-plan-data");
    }
  }, []);

  useEffect(() => {
    if (
      !debtResult ||
      (debtResult?.loans[0] &&
        (debtResult?.loans[0].next_due_fee === 0 ||
          debtResult?.loans[0].next_due_fee === null) &&
        !isCo)
    ) {
      setIsZero(true);
    } else if (canAdvaceFee && !isCo) {
      GAnalyticsService.sendShowInAdvancePayment();
    }
  }, [debtResult]);

  useEffect(() => {
    window.addEventListener("fromApp", (e: any) => {
      const bizumPaymentData = e.detail.paymentData;
      const initTime = e.detail.initTime.$d;
      const advanceFee = e.detail.advanceFee;

      if (bizumPaymentData) {
        handleBizumSuccessEnd(bizumPaymentData, initTime, advanceFee);
      }
    });

    return () => {
      window.removeEventListener("fromApp", (e: any) => {});
    };
  }, []);

  return (
    <ModalWrapper id="success-page">
      <ImgWrapper id="success-img-wrapper">
        <ModalImgDiv
          src={SuccessImg}
          id="success-image"
          alt="success image"
          title="success"
          width={""}
          height={""}
        />
      </ImgWrapper>
      <ModalTextWrapper id="success-title-wrapper">
        <TextBold
          fontSize={24}
          align="center"
          id="success-title"
          fontWeight={700}
          lineHeight={32}
        >
          Completado con éxito
        </TextBold>
      </ModalTextWrapper>
      <ModalTextWrapper id="success-text-wrapper">
        {isVerifyCard ? (
          <TextRegular
            id="success-text"
            fontSize={18}
            fontWeight={400}
            lineHeight={24}
            color="gray6"
          >
            Hemos actualizado los datos de tu tarjeta. Recuerda que en la App
            Pepper Clientes puedes consultar el detalle de tus financiaciones.
          </TextRegular>
        ) : (
          <TextRegular
            id="success-text"
            fontSize={18}
            fontWeight={400}
            lineHeight={24}
            color="gray6"
          >
            Hemos recibido tu pago,{" "}
            <TextRegular
              fontSize={18}
              id="success-text"
              fontWeight={700}
              lineHeight={24}
              color="gray6"
            >
              {" "}
              en unos minutos
            </TextRegular>{" "}
            se aplicará al importe de tu préstamo. Recuerda que en la App Pepper
            Clientes puedes consultar el detalle de tus financiaciones.
          </TextRegular>
        )}
      </ModalTextWrapper>

      <SuccessButtonContainer id="success-button-container">
        {canAdvaceFee && !advanceFeeOK && !isZero && !isCo && (
          <Button
            click={() => handleAdvanceFee()}
            color={white}
            borderColor={red4}
            backgroundColor={red4}
            minWidth="280px"
            id="advance-fee-btn"
          >
            <TextRegular
              fontSize={18}
              color={white}
              lineHeight={20}
              fontWeight={700}
            >
              Adelanta la próxima cuota
            </TextRegular>
          </Button>
        )}
        {viewMode !== ViewMode.IFRAME && (
          <Button
            click={() => handleRedirection()}
            color={
              canAdvaceFee && !advanceFeeOK && !isZero && !isCo ? red4 : white
            }
            borderColor={
              canAdvaceFee && !advanceFeeOK && !isZero && !isCo ? red4 : white
            }
            backgroundColor={
              canAdvaceFee && !advanceFeeOK && !isZero && !isCo ? white : red4
            }
            minWidth="280px"
            border="2px solid"
            id="success-end-btn"
          >
            <TextRegular
              fontSize={18}
              color={white}
              lineHeight={20}
              fontWeight={700}
            >
              Finaliza
            </TextRegular>
          </Button>
        )}
      </SuccessButtonContainer>
    </ModalWrapper>
  );
};

export default Success;
